/** @typedef {import('../types/auth').MerchantUser} MerchantUser */
/** @typedef {import('../types/team').Role} Role */
/** @typedef {import('../types/team').InviteToken} InviteToken */
/** @typedef {import('../types/team').InvitePayload} InvitePayload */
/** @typedef {import('../types/team').CreateRolePayload} CreateRolePayload */
/** @typedef {import('../types/team').AcceptInvitePayload} AcceptInvitePayload */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { instance } from '../config/api';

/** @returns {Promise<ApiResponse<MerchantUser[]>>} */
export const fetchTeamMembers = async () => {
  const { data } = await instance.get('teams/members');
  return data;
};

/** @returns {Promise<ApiResponse<Role[]>>} */
export const fetchRoles = async () => {
  const { data } = await instance.get('teams/roles');
  return data;
};

/**
 * @param {InvitePayload} payload
 * @returns {Promise<MerchantUser>}
 */
export const inviteTeamMember = async (payload) => {
  const { data } = await instance.post('/teams/invite', payload);
  return data.data;
};

/**
 * @param {CreateRolePayload} payload
 * @returns {Promise<Role>}
 */
export const createRole = async (payload) => {
  const { data } = await instance.post('/teams/roles', payload);
  return data.data;
};

/**
 * @param {{ userId: string, roleId: string }} params
 * @returns {Promise<Object>}
 */
export const updateTeamMemberRole = async ({ userId, roleId }) => {
  const { data } = await instance.patch(`/teams/member/${userId}/role`, { role_id: roleId });
  return data.data;
};

/**
 * @param {string} userId
 * @returns {Promise<Object>}
 */
export const resendTeamMemberInvite = async (userId) => {
  const { data } = await instance.post(`/teams/member/${userId}/invite`);
  return data.data;
};

/**
 * @param {string} token
 * @returns {Promise<Object>}
 */
export const revokeTeamMemberInvite = async (token) => {
  const { data } = await instance.delete(`/teams/invite/${token}`);
  return data.data;
};

/**
 * @param {string} token
 * @returns {Promise<InviteToken>}
 */
export const getInviteDetails = async (token) => {
  const { data } = await instance.get(`/teams/invite/${token}`);
  return data.data;
};

/**
 * @param {AcceptInvitePayload} payload
 * @returns {Promise<MerchantUser>}
 */
export const acceptInvite = async (payload) => {
  const { data } = await instance.post('/teams/onboarding', payload);
  return data.data;
};
